'use strict';

import React    from 'react'
import ReactDOM from 'react-dom'

import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import { StylesProvider }                from '@material-ui/core/styles'

import { frFR } from '@material-ui/core/locale'

import Application from '@root/Application'

// https://material-ui.com/customization/default-theme/
const theme = createMuiTheme(
{
	typography:
	{
		fontFamily: 'inherit',
		fontSize: 14
	},

	breakpoints:
	{
		values:
		{
			xs: 0,
			sm: 768,
			md: 1024,
			lg: 1326,
			xl: 1400
		}
	}
},
frFR);

document.addEventListener('DOMContentLoaded', function ()
{
	ReactDOM.render
	(
		(
			<StylesProvider injectFirst>
				<ThemeProvider theme={ theme }>
					<Application />
				</ThemeProvider >
			</StylesProvider>
		),

		document.getElementById('app-mount')
	);
});

document.addEventListener('DOMContentLoaded', function ()
{
	var optimizedResize = (function()
	{
		var callbacks = [], running = false;

		// fired on resize event
		function resize ()
		{
			if (!running)
			{
				running = true;

				if (window.requestAnimationFrame)
				{
					window.requestAnimationFrame(runCallbacks);
				}
				else
				{
					setTimeout(runCallbacks, 66);
				}
			}

		}

	// run the actual callbacks
		function runCallbacks ()
		{
			callbacks.forEach(function (callback)
			{
				callback();
			});

			running = false;
		}

	// adds callback to loop
		function addCallback(callback)
		{
			if (callback)
			{
				callbacks.push(callback);
			}
		}

		var returned =
		{
		// public method to add additional callback
			add: function (callback)
			{
				if (!callbacks.length)
				{
					window.addEventListener('resize', resize);
				}

				addCallback(callback);
			}
		};

		return returned;
	}());

// start process
	optimizedResize.add(function ()
	{
		app.emit('documentResized');
	});
});